import * as clientsActions from "../../actions/clientsActions/constants";

const initialState = {
  clients: [],
  client: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case clientsActions.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
      };
    case clientsActions.SET_CLIENT:
      return {
        ...state,
        client: action.payload,
      };
    default:
      return state;
  }
};
